// extracted by mini-css-extract-plugin
export default {"tableRow":"LoanTypeSelectionTable_tableRow__ArP4T"};